///import { showConfigurationModal } from '../actions';
import * as actionTypes from '../actions/actionTypes'
import _ from 'lodash';

const initialState = () => {

    const stateFromLocalStorage = localStorage.getItem("shoppingCart")

    if (stateFromLocalStorage) {

        const localState = JSON.parse(stateFromLocalStorage)
        const isExpress = localState.isExpress === true
        const items = reconcileCartItemsForExpressMode(localState.items || [], isExpress)
        const itemsPrice = calculateItemsPrice(items)
        const stateForTotals = { ...localState, items, isExpress, itemsPrice }
        const baseTotals = calculateTotalPrice({
            itemsPrice,
            shippingPrice: localState.shippingPrice || 0,
            codeType: null,
            codeValue: null,
            state: stateForTotals
        })

        return {
            ...localState,
            items,
            isExpress,
            itemsPrice,
            pickupLocationConfirmed: false,
            deliveryLocationConfirmed: false,
            selfPickUp: false,
            selfDelivery: false,
            deliveryDatesAvailable: deliveryDatesAvailable(items),
            numberOfDeliveries: 1,
            giftcard: null,
            codeType: null,
            codeValue: null,
            welcomecode: null,
            codeUsed: false,
            orderId: null,
            paymentLink: null,
            newItemAddedOverlay: false,
            newItemEditIndex: false,
            newItemOverlayProduct: null,
            newItemOverlayVariants: [],
            expressPrice: 0,
            userEmail: localState.userEmail ?? null,
            ...withDomainDiscount(stateForTotals, baseTotals)
        }
    }

    return {
        itemsCount: 0,
        items: [],
        isExpress: false,
        itemsPrice: 0,
        selfPickUp: false,
        selfDelivery: false,
        pickupLocationConfirmed: false,
        deliveryLocationConfirmed: false,
        bonus: 0,
        totalPrice: 0,
        shippingPrice: 0,
        deliveryDatesAvailable: [],
        giftcard: null,
        codeType: null,
        codeValue: null,
        welcomecode: null,
        codeUsed: false,
        orderId: null,
        paymentLink: null,
        newItemAddedOverlay: false,
        newItemEditIndex: false,
        newItemOverlayVariants: [],
        expressPrice: 0,
        userEmail: null
    }
};

const removeAllProductsFromShoppongCart = (state) => {
    return ({
        ...state,
        isExpress: false,
        itemsCount: 0,
        items: [],
        itemsPrice: 0,
        selfPickUp: false,
        selfDelivery: false,
        pickupLocationConfirmed: false,
        deliveryLocationConfirmed: false,
        bonus: 0,
        totalPrice: 0,
        shippingPrice: 0,
        deliveryDatesAvailable: [],
        giftcard: null,
        codeType: null,
        codeValue: null,
        welcomecode: null,
        codeUsed: false,
        userEmail: state.userEmail
    })
}

const calculateItemsPrice = (items) => {
    let itemsPrice = 0

    items.forEach(item => {
        itemsPrice += item.sumPrice
    });
    

    return itemsPrice
}

const calculateTotalPrice = ({ itemsPrice, shippingPrice, state, codeType, codeValue }) => {

    switch (codeType) {
        case "welcomecode":
            if ((itemsPrice + shippingPrice) > 30) {

               if(window._paq) window._paq.push(['trackEcommerceCartUpdate', (itemsPrice + shippingPrice) - codeValue]); 

                return { totalPrice: (itemsPrice + shippingPrice) - codeValue, bonus: codeValue }
            }
            break;

        case "giftcard":
            if ((itemsPrice + shippingPrice) >= codeValue) {

               if(window._paq) window._paq.push(['trackEcommerceCartUpdate', (itemsPrice + shippingPrice) - codeValue]); 

                return { totalPrice: (itemsPrice + shippingPrice) - codeValue, bonus: codeValue }
            } else
                return { totalPrice: 0, bonus: (itemsPrice + shippingPrice) }
    }
    if(!codeType && window._paq) {
        window._paq.push(['trackEcommerceCartUpdate', itemsPrice + shippingPrice]);
    }

    return { totalPrice: itemsPrice + shippingPrice, bonus: 0 }
}

const DOMAIN_DISCOUNT_RATE_CLIENT = 10

const parseEligibleDomainsFromEnv = () => {
    const raw = (process.env.REACT_APP_DOMAIN_DISCOUNT_ELIGIBLE_DOMAINS || '').replace(/^\uFEFF/, '').trim()
    return raw.split(',').map((d) => d.trim().toLowerCase().replace(/^@/, '')).filter(Boolean)
}

const domainMatchesEligibleListClient = (emailDomain, eligibleList) => {
    if (!emailDomain || !eligibleList.length) return false
    const d = emailDomain.toLowerCase()
    if (eligibleList.includes(d)) return true
    return false
}

const userHasDomainDiscountClient = (email) => {
    if (!email || typeof email !== 'string') return false
    const parts = email.trim().toLowerCase().split('@')
    if (parts.length !== 2 || !parts[1]) return false
    const list = parseEligibleDomainsFromEnv()
    return list.length > 0 && domainMatchesEligibleListClient(parts[1], list)
}

const mergeDomainDiscount = (state, baseTotals) => {
    if (!userHasDomainDiscountClient(state.userEmail)) {
        return {
            domainDiscountApplied: false,
            domainDiscountRate: 0,
            domainDiscountLabel: null,
            domainDiscountAmount: 0,
            totalPrice: baseTotals.totalPrice,
            bonus: baseTotals.bonus,
        }
    }
    const rate = DOMAIN_DISCOUNT_RATE_CLIENT
    const domainPart = state.userEmail.trim().toLowerCase().split('@')[1] || ''
    const amount = Math.round((Math.max(0, baseTotals.totalPrice) * (rate / 100) + Number.EPSILON) * 100) / 100
    return {
        domainDiscountApplied: true,
        domainDiscountRate: rate,
        domainDiscountLabel: domainPart ? `${domainPart} ${rate}%` : null,
        domainDiscountAmount: amount,
        totalPrice: Math.round((Math.max(0, baseTotals.totalPrice - amount) + Number.EPSILON) * 100) / 100,
        bonus: baseTotals.bonus,
    }
}

const withDomainDiscount = (state, baseTotals) => mergeDomainDiscount(state, baseTotals)

const calculateItemPriceInitialAdd = (product, state) => {
    if (product.laundry) {
        if (product.laundry.perKilo) {
            if (product.laundry.washingPerKiloPrice > 0) {
                product.itemPrice = product.laundry.washingPerKiloPrice
                product.sumPrice = product.laundry.washingPerKiloPrice
            } else {
                product.itemPrice = product.laundry.washingAndIroningPerKiloPrice
                product.sumPrice = product.laundry.washingAndIroningPerKiloPrice
            }
            if (state.isExpress) {
                const perKiloExpressPrice = product.laundry.washingAndIroningSpeedyPrice > 0
                    ? product.laundry.washingAndIroningSpeedyPrice
                    : product.laundry.washingPerKiloPrice;
                product.itemPrice = product.itemPrice + (perKiloExpressPrice || 0)
                product.sumPrice = product.sumPrice + (perKiloExpressPrice || 0)
            }
        } /*else if ((product.laundry.washingAndManualIroningPrice || 0) > 0) {
            product.laundry.washingAndManualIroningSelected = true
            product.itemPrice = product.laundry.washingAndManualIroningPrice
            product.sumPrice = product.laundry.washingAndManualIroningPrice
            if(state.isExpress){
                product.itemPrice = product.laundry.washingAndIroningSpeedyPrice;
                product.sumPrice = product.laundry.washingAndIroningSpeedyPrice;
            }
        } */else {
            product.laundry.washingAndIroningSelected = true
            product.itemPrice = product.laundry.washingAndIroningPrice
            product.sumPrice = product.laundry.washingAndIroningPrice
            if(state.isExpress){
                product.itemPrice = product.laundry.washingAndIroningPrice;
                product.sumPrice = product.laundry.washingAndIroningPrice;
            }

        }
    } else if (product.leather) {
        if ((product.leather.velourPrice || 0) > 0) {
            product.leather.velourSelected = true
            product.itemPrice = product.leather.velourPrice
            product.sumPrice = product.leather.velourPrice
        } else if ((product.leather.napaPrice || 0) > 0) {
            product.leather.napaSelected = true
            product.itemPrice = product.leather.napaPrice
            product.sumPrice = product.leather.napaPrice
        }
    }
    if (product.delivery) {
        if (product.delivery.packed && product.delivery.packedPrice === 0) {
            product.delivery.packedSelected = true
        } else if (product.delivery.hanger && product.delivery.hangerPrice === 0) {
            product.delivery.hangerSelected = true
        }
    }
    if (product.giftCard) {
        product.itemPrice = product.giftCard.price
        product.sumPrice = product.giftCard.price
        product.giftCart = 'Als Geschenk für Dich "Ein Moment der Entspannung". Geniesse Deine Freizeit!'
    }
    product.itemQuantity = 1
}

const deliveryDatesAvailable = items => {
    if (!items || items.length === 0) {
        return [1];
    }

    // Check if ALL items have longProcessing (not just some)
    const allLongProcessing = items.length > 0 && items.every(item => item.longProcessing > 0);

    // If ALL items are longProcessing, return 14 days for both regular and express orders
    if (allLongProcessing) {
        return [14];
    }

    // Mixed cart or no longProcessing items - standard delivery times
    return [1];
}

const showConfigurationModal = (state, { product, variants, itemIndex = false }) => {
    if(itemIndex !== false){ // edit mode
        state.newItemOverlayProduct = product; 
        state.newItemOverlayVariants = variants;
        state.newItemAddedOverlay = true;
        state.newItemEditIndex = itemIndex; 
        return returnStateAfterItemCheck({ state, newItems: state.items, itemsCount: state.itemsCount })
    } else {
        let newItems = [state.newItemOverlayProduct]
        let newVariants = [];
        if(variants.length>0){
            variants.forEach(variant => {
                let newVariant = _.cloneDeep(variant)
                calculateItemPriceInitialAdd(newVariant, state)
                newVariants.push(newVariant)
            })
            newVariants.sort((a, b) => a.sumPrice - b.sumPrice);
        }   
        
        // Use the product ID to find the specific product from variants
        let newProduct;
        if (product && product._id) {
            // Find the product with the matching ID from variants
            newProduct = newVariants.find(variant => variant._id === product._id);
        }
        
        // Fallback to first variant if product not found or no product ID provided
        if (!newProduct && newVariants.length > 0) {
            newProduct = newVariants[0];
        }

        state.newItemOverlayProduct = newProduct; 
        state.newItemOverlayVariants = newVariants;
        state.newItemAddedOverlay = true; 
        newItems = [newProduct]
        return returnStateAfterItemCheck({ state, newItems, itemsCount: state.itemsCount })
    }
}

const addProductToShoppongCart = (state, { product, variants }) => {
    let newItems = _.cloneDeep(state.items)
    product = state.newItemOverlayProduct;
    variants = state.newItemOverlayVariants;
    checkAndTurnOffSpeedyOptionForOldItems(newItems, product)
    checkAndTurnOnSpeedyOptionForNewItem(newItems, product)
    newItems.push(product)
    state.newItemOverlayProduct = null; 
    state.newItemOverlayVariants = null;
    state.newItemAddedOverlay = false; 
    state.newItemEditIndex = false;

    if(window._paq) window._paq.push(['addEcommerceItem',
        product._id, // (Required) productSKU
        product.name, // (Optional) productName
        product.category.name, // (Optional) productCategory
        product.sumPrice, // (Recommended) price
        1 // (Optional, defaults to 1) quantity
    ]);

    return returnStateAfterItemCheck({ state, newItems, itemsCount: state.itemsCount + product.itemQuantity })
}

const checkAndTurnOnSpeedyOptionForNewItem = (items, product) => {
    if (items.length > 0 && items.every(item => item.laundry && item.laundry.washingAndIroningSpeedySelected === true)) {
        if (product.laundry && product.laundry.washingAndIroningSpeedy) {
            product.laundry.washingAndIroningSelected = false
            product.laundry.washingAndIroningSpeedySelected = true
            product.itemPrice = product.itemPrice + product.laundry.washingAndIroningSpeedyPrice
            product.sumPrice = product.itemPrice
        }
    }
}

const checkAndTurnOffSpeedyOptionForOldItems = (items, product) => {
    //Turn off speedy item if item added doesn't have speedy option
    if (product.longProcessing || (product.laundry ? product.laundry.washingAndIroningSpeedy === false : false)) {
        items.forEach(item => {
            if (item.laundry) {
                if (item.laundry.washingAndIroningSpeedySelected === true) {
                    item.laundry.washingAndIroningSpeedySelected = false
                    item.laundry["washingAndIroningSelected"] = true
                    item.itemPrice = item.itemPrice - item.laundry.washingAndIroningSpeedyPrice
                    item.sumPrice = item.itemPrice * item.itemQuantity
                }
            }
        });
    }
}

const removeProductFromShoppongCart = (state, { productIndex }) => {
    const newItems = state.items.map(product => _.cloneDeep(product))

    let itemToRemove = newItems[productIndex];
    newItems.splice(productIndex, 1)

    return returnStateAfterItemCheck({ state, newItems, itemsCount: state.itemsCount - itemToRemove.itemQuantity })
}

const removeTempProductFromShoppongCart = (state, { productIndex }) => {
    state.newItemAddedOverlay = false;
    state.newItemEditIndex = false;
    state.newItemOverlayProduct = false;
    return returnStateAfterItemCheck({ state, newItems: state.items, itemsCount: state.itemsCount })
}

const calculatePrice = (item, isExpress) => {
    let itemPrice = 0
    item.sumPrice = 0

    if (item.laundry) {
        let laundryPrice = 0
        if (item.laundry.perKilo) {
            if (item.laundry.washingPerKiloPrice > 0) {
                laundryPrice = item.laundry.washingPerKiloPrice
            } else {
                laundryPrice = item.laundry.washingAndIroningPerKiloPrice
            }
            if (isExpress) {
                const perKiloExpressPrice = item.laundry.washingAndIroningSpeedyPrice > 0
                    ? item.laundry.washingAndIroningSpeedyPrice
                    : item.laundry.washingPerKiloPrice;
                laundryPrice += (perKiloExpressPrice || 0)
            }
        
        } else if (item.laundry.washingAndIroningSelected) {
            laundryPrice = item.laundry.washingAndIroningPrice
            if(isExpress) laundryPrice += item.laundry.washingAndIroningSpeedyPrice
        } else if (item.laundry.washingAndManualIroningSelected) {
            laundryPrice = item.laundry.washingAndManualIroningPrice
            if(isExpress) laundryPrice += item.laundry.washingAndIroningSpeedyPrice
        } else if (item.laundry.washingAndManualIroningSpeedySelected) {
            laundryPrice = item.laundry.washingAndManualIroningPrice + (item.laundry.washingAndManualIroningSpeedy === true ? item.laundry.washingAndIroningSpeedyPrice : 0)
        } else {
            // Standalone "wash & iron express" (washingAndIroningSpeedySelected): must follow order isExpress,
            // same as wash+iron — otherwise polo-type items keep CHF speedy when express is off (other options use if(isExpress) above).
            laundryPrice = item.laundry.washingAndIroningPrice
            if (isExpress && item.laundry.washingAndIroningSpeedy === true) {
                laundryPrice += item.laundry.washingAndIroningSpeedyPrice
            }
        }
        item.sumPrice = laundryPrice * item.itemQuantity
        itemPrice = laundryPrice
    }
    if (item.tailoring) {
        let tailoring = 0
        if (item.tailoring.buttonSelected) {
            tailoring = tailoring + (item.tailoring.buttonQuantity * item.tailoring.buttonPrice)
        }
        if (item.tailoring.zipperSelected) {
            tailoring = tailoring + (item.tailoring.zipperQuantity * item.tailoring.zipperPrice)
        }
        if (item.tailoring.hemSelected) {
            tailoring = tailoring + (item.tailoring.hemQuantity * item.tailoring.hemPrice)
        }
        item.sumPrice = item.sumPrice + tailoring
    }
    if (item.delivery) {
        let delivery = 0
        if (item.delivery.packedSelected) {
            delivery = delivery + item.delivery.packedPrice
        }
        if (item.delivery.hangerSelected) {
            delivery = delivery + item.delivery.hangerPrice
        }
        item.sumPrice = item.sumPrice + delivery * item.itemQuantity
        itemPrice = itemPrice + delivery
    }
    if (item.additional) {
        let additional = 0
        if (item.additional.decorationSelected) {
            additional = additional + item.additional.decorationPrice
        }
        if (item.additional.platedSelected) {
            additional = additional + item.additional.platedPrice
        }
        if (item.additional.sequinedSelected) {
            additional = additional + item.additional.sequinedPrice
        }
        if (item.additional.rufflesSelected) {
            additional = additional + item.additional.rufflesPrice
        }
        if (item.additional.bibSelected) {
            additional = additional + item.additional.bibPrice
        }
        if (item.additional.longSelected) {
            additional = additional + item.additional.longPrice
        }
        if (item.additional.impregnateSelected) {
            additional = additional + item.additional.impregnatePrice
        }
        if (item.additional.chiffonSelected) {
            additional = additional + item.additional.chiffonPrice
        }
        item.sumPrice = item.sumPrice + additional * item.itemQuantity
        itemPrice = itemPrice + additional
    }

    if (item.leather) {
        let leatherPrice = 0
        if (item.leather.velourSelected) {
            leatherPrice = leatherPrice + item.leather.velourPrice
        }
        if (item.leather.napaSelected) {
            leatherPrice = leatherPrice + item.leather.napaPrice
        }
        item.sumPrice = item.sumPrice + leatherPrice * item.itemQuantity
        itemPrice = itemPrice + leatherPrice
    }

}

const reconcileCartItemsForExpressMode = (items, isExpress) => {
    if (!items || !items.length) return items || []
    const newItems = items.map(p => _.cloneDeep(p))
    newItems.forEach(item => {
        if (!item.laundry) return
        if (!isExpress) {
            if (
                item.laundry.washingAndIroningSpeedy === true &&
                item.laundry.washingAndIroningSpeedySelected &&
                !item.laundry.washingAndIroningSelected &&
                !item.laundry.washingAndManualIroningSelected
            ) {
                item.laundry.washingAndIroningSpeedySelected = false
                item.laundry.washingAndIroningSelected = true
            }
        }
        calculatePrice(item, isExpress)
    })
    return newItems
}

const variantCheck = (state, { itemIndex, variantId }) => {
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))
    newItems.forEach((item, index) => {
        if (index === itemIndex) {
            const matchingVariant = state.newItemOverlayVariants.find(variant => variant._id == variantId);
            if (matchingVariant) {
                newItems[index] = matchingVariant;
                calculatePrice(newItems[index], state.isExpress);
            }
        }
    });

    return returnStateAfterItemCheck({ state, newItems })
}

const noLaundryCheck = (state, { itemIndex }) => {
    
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))

    newItems.forEach((item, index) => {
        if (index === itemIndex) {
            item.laundry.noLaundrySelected = true
            item.laundry.washingAndIroningSelected = false
            item.laundry.washingAndManualIroningSelected = false
            item.laundry.washingAndIroningSpeedySelected = false
            calculatePrice(item, state.isExpress)
        } else {
            if (item.laundry && item.laundry.washingAndIroningSpeedySelected === true) {
                item.laundry.noLaundrySelected = false
                item.laundry.washingAndIroningSelected = true
                item.laundry.washingAndManualIroningSelected = false
                item.laundry.washingAndIroningSpeedySelected = false
                calculatePrice(item, state.isExpress)
            }
        }
    });


    return returnStateAfterItemCheck({ state, newItems })
}

const washingAndIroningCheck = (state, { itemIndex }) => {

    
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))
    newItems.forEach((item, index) => {
        if (index === itemIndex) {
            item.laundry.noLaundrySelected = false
            item.laundry.washingAndIroningSelected = true
            item.laundry.washingAndManualIroningSelected = false
            item.laundry.washingAndIroningSpeedySelected = false
            calculatePrice(item, state.isExpress)
        } else {
            if (item.laundry && item.laundry.washingAndIroningSpeedySelected === true) {
                item.laundry.noLaundrySelected = false
                item.laundry.washingAndIroningSelected = true
                item.laundry.washingAndManualIroningSelected = false
                item.laundry.washingAndIroningSpeedySelected = false
                calculatePrice(item, state.isExpress)
            }
        }
    });

    return returnStateAfterItemCheck({ state, newItems })
}

const washingAndManualIroningCheck = (state, { itemIndex }) => {

    
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))
    newItems.forEach((item, index) => {
        if (index === itemIndex) {
            item.laundry.noLaundrySelected = false
            item.laundry.washingAndIroningSelected = false
            item.laundry.washingAndManualIroningSelected = true
            item.laundry.washingAndIroningSpeedySelected = false
            calculatePrice(item, state.isExpress)
        } else {
            if (item.laundry && item.laundry.washingAndIroningSpeedySelected === true) {
                item.laundry.noLaundrySelected = false
                item.laundry.washingAndIroningSelected = false
                item.laundry.washingAndManualIroningSelected = true
                item.laundry.washingAndIroningSpeedySelected = false
                calculatePrice(item, state.isExpress)
            }
        }
    });

    return returnStateAfterItemCheck({ state, newItems })
}

const washingAndIroningSpeedyCheck = (state, { itemIndex }) => {

    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))

    newItems.forEach(item => {
        if (item.laundry) {
            item.laundry.noLaundrySelected = false
            item.laundry.washingAndIroningSelected = false
            item.laundry.washingAndManualIroningSelected = false
            item.laundry.washingAndIroningSpeedySelected = true
            calculatePrice(item, state.isExpress)
        }
    });

    return returnStateAfterItemCheck({ state, newItems })
}

const buttonCheck = (state, { itemIndex }) => {
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))

    if (!newItems[itemIndex].tailoring.buttonSelected)
        newItems[itemIndex].tailoring.buttonQuantity = 1
    newItems[itemIndex].tailoring.buttonSelected = !newItems[itemIndex].tailoring.buttonSelected
    calculatePrice(newItems[itemIndex], state.isExpress)

    return returnStateAfterItemCheck({ state, newItems })
}

const hemCheck = (state, { itemIndex }) => {

    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))

    if (!newItems[itemIndex].tailoring.hemSelected)
        newItems[itemIndex].tailoring.hemQuantity = 1
    newItems[itemIndex].tailoring.hemSelected = !newItems[itemIndex].tailoring.hemSelected
    calculatePrice(newItems[itemIndex], state.isExpress)

    return returnStateAfterItemCheck({ state, newItems })
}

const zipperCheck = (state, { itemIndex }) => {

    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))

    if (!newItems[itemIndex].tailoring.zipperSelected)
        newItems[itemIndex].tailoring.zipperQuantity = 1
    newItems[itemIndex].tailoring.zipperSelected = !newItems[itemIndex].tailoring.zipperSelected
    calculatePrice(newItems[itemIndex], state.isExpress)

    return returnStateAfterItemCheck({ state, newItems })
}

const returnStateAfterItemCheck = ({ state, newItems, itemsCount }) => {
    if(state.newItemOverlayProduct && state.newItemEditIndex === false){
        state.newItemOverlayProduct = _.clone(newItems[0])
        newItems = state.items;
    }
    const itemsPrice = calculateItemsPrice(newItems)
    const deliveryDates = deliveryDatesAvailable(newItems)
    return ({
        ...state,
        itemsCount: itemsCount !== undefined ? itemsCount : state.itemsCount,
        items: newItems,
        itemsPrice: itemsPrice,
        shippingPrice: 0,
        pickupLocationConfirmed: false,
        deliveryLocationConfirmed: false,
        deliveryDatesAvailable: deliveryDates,
        numberOfDeliveries: deliveryDates.length !== 2 ? 1 : state.numberOfDeliveries,
        ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice, shippingPrice: 0, codeType: state.codeType, codeValue: state.codeValue, state }))
    })
}

const quantityAdd = (state, { itemIndex, itemType }) => {
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))
    let itemsCount = state.itemsCount;
    switch (itemType) {
        case "item":
            newItems[itemIndex].itemQuantity = (newItems[itemIndex].itemQuantity || 1) + 1
            // newItems[itemIndex].sumPrice = newItems[itemIndex].itemPrice * newItems[itemIndex].itemQuantity
            calculatePrice(newItems[itemIndex], state.isExpress)

            break;
        default:
            newItems[itemIndex].tailoring[`${itemType}Quantity`] = (newItems[itemIndex].tailoring[`${itemType}Quantity`] || 1) + 1
            calculatePrice(newItems[itemIndex], state.isExpress)
            break;
    }

    return returnStateAfterItemCheck({ state, newItems, itemsCount: (state.newItemOverlayProduct ? itemsCount : itemsCount+1) })
}

const quantityRemove = (state, { itemIndex, itemType }) => {

    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))
    let itemsCount = state.itemsCount;

    switch (itemType) {
        case "button":
            newItems[itemIndex].tailoring.buttonQuantity = (newItems[itemIndex].tailoring.buttonQuantity || 1) - 1
            calculatePrice(newItems[itemIndex], state.isExpress)
            break;
        case "zipper":
            newItems[itemIndex].tailoring.zipperQuantity = (newItems[itemIndex].tailoring.zipperQuantity || 1) - 1
            calculatePrice(newItems[itemIndex], state.isExpress)
            break;
        case "hem":
            newItems[itemIndex].tailoring.hemQuantity = (newItems[itemIndex].tailoring.hemQuantity || 1) - 1
            calculatePrice(newItems[itemIndex], state.isExpress)
            break;
        case "item":
            newItems[itemIndex].itemQuantity = (newItems[itemIndex].itemQuantity || 1) - 1
            calculatePrice(newItems[itemIndex], state.isExpress)

            break;
        default:
            break;
    }

    return returnStateAfterItemCheck({ state, newItems, itemsCount: (state.newItemOverlayProduct ? itemsCount : itemsCount-1) })
}

const deliveryCheck = (state, { itemIndex }) => {

    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))

    if (newItems[itemIndex].delivery.packed && newItems[itemIndex].delivery.hanger) {
        newItems[itemIndex].delivery.packedSelected = !newItems[itemIndex].delivery.packedSelected
        newItems[itemIndex].delivery.hangerSelected = !newItems[itemIndex].delivery.packedSelected
    }

    calculatePrice(newItems[itemIndex], state.isExpress)

    return returnStateAfterItemCheck({ state, newItems })
}


const leatherTypeCheck = (state, { itemIndex }) => {

    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))

    newItems[itemIndex].leather.napaSelected = !newItems[itemIndex].leather.napaSelected
    newItems[itemIndex].leather.velourSelected = !newItems[itemIndex].leather.velourSelected
    newItems[itemIndex].itemPrice = (newItems[itemIndex].leather.velourSelected ?
        newItems[itemIndex].leather.velourPrice : newItems[itemIndex].leather.napaPrice)
    newItems[itemIndex].sumPrice = newItems[itemIndex].itemPrice * newItems[itemIndex].itemQuantity

    return returnStateAfterItemCheck({ state, newItems })
}

const additionalCheck = (state, { itemIndex, checkType }) => {
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))
    newItems[itemIndex].additional[checkType] = !newItems[itemIndex].additional[checkType]
    calculatePrice(newItems[itemIndex], state.isExpress)

    return returnStateAfterItemCheck({ state, newItems })
}

const applyPromoCodeSuccess = (state, { code, codeType, value }) => ({
    ...state,
    items: JSON.parse(JSON.stringify(state.items)),
    [codeType]: code,
    codeUsed: true,
    codeType: codeType,
    codeValue: value,
    ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice: state.itemsPrice, shippingPrice: state.shippingPrice, codeType, codeValue: value, state }))
})

const deleteCode = (state) => {
    return ({
        ...state,
        welcomecode: null,
        giftcard: null,
        codeUsed: false,
        codeType: null,
        items: JSON.parse(JSON.stringify(state.items)),
        ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice: state.itemsPrice, shippingPrice: state.shippingPrice, state }))
    })
}

const calculateShippingPrice = ({ itemsPrice, selfPickUp, selfDelivery, pickupLocationConfirmed, deliveryLocationConfirmed, isVip, numberOfDeliveries, userEmail }) => {

    if (isVip)
        return 0

    if (pickupLocationConfirmed !== true && deliveryLocationConfirmed !== true)
        return 0

    if (itemsPrice === 0)
        return 0

    if (itemsPrice > 30)
        return 0

    if (selfPickUp && selfDelivery)
        return 0

    let shippingPrice = 0

    if (!selfPickUp && pickupLocationConfirmed === true)
        shippingPrice = shippingPrice + 7.5

    if (!selfDelivery && deliveryLocationConfirmed === true) {
        if (numberOfDeliveries === 2) {
            shippingPrice = shippingPrice + 15
        } else {
            shippingPrice = shippingPrice + 7.5
        }
    }

    if (userHasDomainDiscountClient(userEmail))
        return 0

    return shippingPrice
}

const shippingPriceFromCartState = (state, isVip) =>
    calculateShippingPrice({
        itemsPrice: state.itemsPrice,
        selfPickUp: state.selfPickUp,
        selfDelivery: state.selfDelivery,
        pickupLocationConfirmed: state.pickupLocationConfirmed,
        deliveryLocationConfirmed: state.deliveryLocationConfirmed,
        isVip,
        numberOfDeliveries: state.numberOfDeliveries,
        userEmail: state.userEmail
    })

const confirmWithoutAddress = (state, { addressType }) => {
    let shippingPrice
    switch (addressType) {
        case 1:
            shippingPrice = calculateShippingPrice({
                itemsPrice: state.itemsPrice,
                selfPickUp: true,
                selfDelivery: state.selfDelivery,
                pickupLocationConfirmed: true,
                deliveryLocationConfirmed: state.deliveryLocationConfirmed,
                numberOfDeliveries: state.numberOfDeliveries,
                userEmail: state.userEmail,
                eligibleDomains: state.domainDiscountEligibleDomains
            })
            return ({
                ...state,
                selfPickUp: true,
                pickupLocationConfirmed: true,
                shippingPrice: shippingPrice,
                items: JSON.parse(JSON.stringify(state.items)),
                ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice: state.itemsPrice, shippingPrice: shippingPrice, codeType: state.codeType, codeValue: state.codeValue, state }))
            })
        default:
            shippingPrice = calculateShippingPrice({
                itemsPrice: state.itemsPrice,
                selfPickUp: state.selfPickUp,
                selfDelivery: true,
                pickupLocationConfirmed: state.pickupLocationConfirmed,
                deliveryLocationConfirmed: true,
                numberOfDeliveries: state.numberOfDeliveries,
                userEmail: state.userEmail
            })
            return ({
                ...state,
                shippingPrice: shippingPrice,
                selfDelivery: true,
                deliveryLocationConfirmed: true,
                numberOfDeliveries: 1,
                items: JSON.parse(JSON.stringify(state.items)),
                ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice: state.itemsPrice, shippingPrice: shippingPrice, codeType: state.codeType, codeValue: state.codeValue, state }))
            })
    }
}


const confirmWithPickUpAddress = (state, { value, isVip }) => {

    const shippingPrice = calculateShippingPrice({
        itemsPrice: state.itemsPrice,
        selfPickUp: false,
        selfDelivery: state.selfDelivery,
        pickupLocationConfirmed: value,
        deliveryLocationConfirmed: value ? state.deliveryLocationConfirmed : false,
        isVip,
        numberOfDeliveries: state.numberOfDeliveries,
        userEmail: state.userEmail
    })
    return ({
        ...state,
        shippingPrice: shippingPrice,
        selfPickUp: false,
        selfDelivery: value ? state.selfDelivery : false,
        pickupLocationConfirmed: value,
        deliveryLocationConfirmed: value ? state.deliveryLocationConfirmed : false,
        items: JSON.parse(JSON.stringify(state.items)),
        ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice: state.itemsPrice, shippingPrice: shippingPrice, codeType: state.codeType, codeValue: state.codeValue, state }))
    })
}

const confirmWithDeliveryAddress = (state, { value, isVip }) => {

    const shippingPrice = calculateShippingPrice({
        itemsPrice: state.itemsPrice,
        selfPickUp: state.selfPickUp,
        selfDelivery: false,
        pickupLocationConfirmed: state.pickupLocationConfirmed,
        deliveryLocationConfirmed: value,
        isVip,
        numberOfDeliveries: state.numberOfDeliveries,
        userEmail: state.userEmail
    })

    return ({
        ...state,
        shippingPrice: shippingPrice,
        selfDelivery: false,
        deliveryLocationConfirmed: value,
        items: JSON.parse(JSON.stringify(state.items)),
        ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice: state.itemsPrice, shippingPrice: shippingPrice, codeType: state.codeType, codeValue: state.codeValue, state }))
    })
}

const changeNumberOfDeliveries = (state, { number }) => {

    let newState = _.cloneDeep(state)
    newState.numberOfDeliveries = parseInt(number, 10)

    return newState
}

const notesChange = (state, { itemIndex, text }) => {

    let newState = _.cloneDeep(state)

    if(state.newItemOverlayProduct){
        newState.newItemOverlayProduct.notes = text
    } else {
        newState.items[itemIndex]["notes"] = text
    }

    return newState
}

const giftCardItemSubmit = (state, { values, itemIndex }) => {
    let newState = _.cloneDeep(state)
    if(state.newItemOverlayProduct) {
        newState.newItemOverlayProduct.giftCard.message = values.message
        newState.newItemOverlayProduct.giftCard.email = values.email
        newState.newItemOverlayProduct.giftCard.name = values.name
        newState.newItemOverlayProduct.giftCard.confirmed = !state.newItemOverlayProduct.giftCard.confirmed
    } else {
        newState.items[itemIndex].giftCard.message = values.message
        newState.items[itemIndex].giftCard.email = values.email
        newState.items[itemIndex].giftCard.name = values.name
        newState.items[itemIndex].giftCard.confirmed = !newState.items[itemIndex].giftCard.confirmed
    }

    return newState
}

export default (state = initialState(), action) => {
    let shoppingCart = reducer(state, action)
    localStorage.setItem("shoppingCart", JSON.stringify(shoppingCart))
    return shoppingCart
};

const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.GIFT_CARD_ITEM_SUBMIT:
            return giftCardItemSubmit(state, action)
        case actionTypes.NOTES_CHANGE:
            return notesChange(state, action)
        case actionTypes.CHANGE_NUMBER_OF_DELIVERIES:
            return changeNumberOfDeliveries(state, action)
        case actionTypes.CONFIRM_WITHOUT_ADDRESS:
            return confirmWithoutAddress(state, action)
        case actionTypes.DELETE_CODE:
            return deleteCode(state, action)
        case actionTypes.APPLY_CODE_SUCCESS:
            return applyPromoCodeSuccess(state, action)
        case actionTypes.REMOVE_ALL_PRODUCTS_FROM_SHOPPING_CART:
            return removeAllProductsFromShoppongCart(state, action)
        case actionTypes.ADDITIONAL_CHECK:
            return additionalCheck(state, action)
        case actionTypes.LEATHER_TYPE_CHECK:
            return leatherTypeCheck(state, action)
        case actionTypes.DELIVERY_CHECK:
            return deliveryCheck(state, action)
        case actionTypes.QUANTITY_ADD:
            return quantityAdd(state, action)
        case actionTypes.QUANTITY_REMOVE:
            return quantityRemove(state, action)
        case actionTypes.ZIPPER_CHECK:
            return zipperCheck(state, action)
        case actionTypes.HEM_CHECK:
            return hemCheck(state, action)
        case actionTypes.BUTTON_CHECK:
            return buttonCheck(state, action)
        case actionTypes.WASHING_AND_IRONING_SPEEDY_CHECK:
            return washingAndIroningSpeedyCheck(state, action)
        case actionTypes.WASHING_AND_IRONING_CHECK:
            return washingAndIroningCheck(state, action)
        case actionTypes.WASHING_AND_MANUAL_IRONING_CHECK:
            return washingAndManualIroningCheck(state, action)    
        case actionTypes.VARIANT_CHECK:
            return variantCheck(state, action)
        case actionTypes.NO_LAUNDRY_CHECK:
            return noLaundryCheck(state, action)
        case actionTypes.REMOVE_FROM_SHOPPING_CART:
            return removeProductFromShoppongCart(state, action)
        case actionTypes.REMOVE_TEMP_FROM_SHOPPING_CART:
            return removeTempProductFromShoppongCart(state, action)
        case actionTypes.ADD_TO_SHOPPING_CART:
            return addProductToShoppongCart(state, action);
        case actionTypes.SHOW_CONFIGURATION_MODAL:
            return showConfigurationModal(state, action);
        case actionTypes.CONFIRM_PICKUP_LOCATION:
            return confirmWithPickUpAddress(state, action)
        case actionTypes.CONFIRM_DELIVERY_LOCATION:
            return confirmWithDeliveryAddress(state, action)
        case 'SUBMIT_ORDER_SUCCESS':
                return {
                    ...state,
                    paymentLink: action.payload.link,
                    orderId: action.payload.id
                };
        case actionTypes.TOGGLE_EXPRESS:
            return toggleExpressCheck(state, action)
        case actionTypes.AUTH_SUCCESS: {
            const next = { ...state, userEmail: action.userEmail != null ? action.userEmail : state.userEmail }
            const shippingPrice = shippingPriceFromCartState(next, action.isVip === true)
            const base = calculateTotalPrice({
                itemsPrice: next.itemsPrice,
                shippingPrice,
                codeType: next.codeType,
                codeValue: next.codeValue,
                state: next
            })
            return {
                ...next,
                shippingPrice,
                ...withDomainDiscount(next, base)
            }
        }
        case actionTypes.AUTH_LOGOUT: {
            const next = { ...state, userEmail: null }
            const shippingPrice = shippingPriceFromCartState(next, false)
            const base = calculateTotalPrice({
                itemsPrice: next.itemsPrice,
                shippingPrice,
                codeType: next.codeType,
                codeValue: next.codeValue,
                state: next
            })
            return {
                ...next,
                shippingPrice,
                ...withDomainDiscount(next, base)
            }
        }
        default:
            return state;
    }
}

export const getItemsCount = state => state.shoppingCart.itemsCount
export const getItems = state => state.shoppingCart.items
export const getItemByIndex = (state, itemIndex) => state.shoppingCart.items[itemIndex]
export const getTempItemByIndex = (state, itemIndex) => state.shoppingCart.tempItems[itemIndex]
export const getLaundryItem = (state, itemIndex) => state.shoppingCart.items[itemIndex].laundry
export const getFinalPrice = (state) => state.shoppingCart.finalPrice

export const showOnlyPaymentOnCheckout = state => {
    return state.shoppingCart.items.every(item => {
        return item.giftCard
    })
}

export const checkoutPageEnabled = state => {
    return state.shoppingCart.items.filter(t => t.giftCard).every(item => {
        return item.giftCard.confirmed
    }) && state.shoppingCart.totalPrice > 0
}

export const onlyGiftCards = state => {
    return state.shoppingCart.items.every(item => item.giftCard)
}

export const hasSpeedyItem = state => {
    return state
        .shoppingCart
        .items
        .map(item => item.laundry || { washingAndIroningSpeedySelected: false })
        .every(laundryItem => laundryItem.washingAndIroningSpeedySelected === true);
}

export const speedyOptionDisabled = state => state
    .shoppingCart
    .items
    .some(t => t.longProcessing || (t.laundry ? t.laundry.washingAndIroningSpeedy === false : false))

export const toggleExpressCheck = (state) => {
    const newItems = state.newItemEditIndex === false && state.newItemOverlayProduct ? [state.newItemOverlayProduct] : state.items.map(product => _.cloneDeep(product))
    state.isExpress = !state.isExpress;

    newItems.forEach(item => {
        if (!item.laundry) return
        if (!state.isExpress) {
            // Only remap products that use the standalone express tier (polo etc.). Skip e.g. cleaning-only SKUs
            // where washingAndIroningSpeedy is false — price is already base-only from calculatePrice.
            if (
                item.laundry.washingAndIroningSpeedy === true &&
                item.laundry.washingAndIroningSpeedySelected &&
                !item.laundry.washingAndIroningSelected &&
                !item.laundry.washingAndManualIroningSelected
            ) {
                item.laundry.washingAndIroningSpeedySelected = false
                item.laundry.washingAndIroningSelected = true
            }
        }
        calculatePrice(item, state.isExpress)
    })

    const itemsPrice = calculateItemsPrice(newItems)
    const deliveryDates = deliveryDatesAvailable(newItems)
    if(!state.selfDelivery) {
       // state.deliveryLocationConfirmed = false;
       // state.pickupLocationConfirmed = false;
    }
    return ({
        ...state,
        items: newItems,
        itemsPrice: itemsPrice,
        deliveryDatesAvailable: deliveryDates,
        ...withDomainDiscount(state, calculateTotalPrice({ itemsPrice, shippingPrice: state.shippingPrice || 0, codeType: state.codeType, codeValue: state.codeValue, state }))
    })

}